/**
 * Client helper: send _advance_lease intent to Lambda.
 * Reused by LeaseDetailsPageLoader, LeaseDetailsDocsLoader, LeaseUpdateTenantCompleteForm.
 */

import { apiClient } from "~/services/apiClient";
import { AdvanceLeasePayload } from "~/types/lease";
import { INTENTS } from "~/utils";

export async function sendAdvanceLeaseIntent(leaseID: string, payload: AdvanceLeasePayload) {
  return apiClient.sendIntent<Record<string, unknown>>(INTENTS._advance_lease, {
    id: leaseID,
    nextAction: payload.nextAction,
    applicationID: payload.applicationID,
    applicationVersion: payload.applicationVersion,
    backgroundCheckID: payload.backgroundCheckID,
    backgroundCheckVersion: payload.backgroundCheckVersion,
    offerID: payload.offerID,
    offerVersion: payload.offerVersion,
    moveInID: payload.moveInID,
    moveInVersion: payload.moveInVersion,
    moveOutID: payload.moveOutID,
    moveOutVersion: payload.moveOutVersion,
    entityID: payload.entityID,
    unitVersion: payload.unitVersion,
    leaseID,
    leaseVersion: payload.leaseVersion,
    tenantID: payload.tenantID,
    tenantVersion: payload.tenantVersion,
  });
}
